export const QP_CACHE_KEY = "qp_cache_key"
export const THANKS_PARAM = "thanks"

function queryParameter(param) {
  return new URLSearchParams(window.location.search).get(param)
}

export default queryParameter
